// Match a single processId or a string of comma seperated processId's e.g. 1234,1345,3456
export const csProcessIdRegex = /^[1-9]\d{0,9}(,[1-9]\d{0,9})*$/;

export const numberRegex = /^[0-9]+$/;

export const kvkNumberRegex = /[0-9]{8}/;

export const agbCodeRegex = /^[0-9]{8}$/;
